var g = Object.defineProperty;
var b = (t, e, n) => e in t ? g(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var c = (t, e, n) => (b(t, typeof e != "symbol" ? e + "" : e, n), n);
import { jsx as u } from "react/jsx-runtime";
import a from "react";
const $ = (t, e = {}) => {
  const n = a.createContext(e);
  return { Context: n, Provider: (o) => /* @__PURE__ */ u(
    t,
    {
      ...o,
      render: (d) => /* @__PURE__ */ u(n.Provider, { value: d, children: o.children })
    }
  ), Consumer: (o) => (d) => /* @__PURE__ */ u(n.Consumer, { children: (f) => /* @__PURE__ */ u(o, { ...f, ...d }) }), Use: () => a.useContext(n) };
};
function x(t = {}, e = {}, n = {}) {
  return Object.entries(e).reduce(
    (r, [i, s]) => {
      const o = n[s];
      return o !== null && typeof o < "u" && (r[i] = o), r;
    },
    { ...t }
  );
}
function C(t, e = []) {
  return (typeof e == "string" ? e.split(/,\s*|\s+/) : e).reduce(
    (r, i) => {
      const s = t[i] || P(`Cannot expose non-existent action method: ${i}`);
      return r[i] = s.bind(t), r;
    },
    {}
  );
}
function m(t, e) {
  const n = t.debug ?? e.debug, r = h(t.debugPrefix ?? e.debugPrefix, t), i = h(t.debugColor ?? e.debugColor, t);
  return n ? r ? (s, ...o) => console.log(
    `%c${r}%c${s}`,
    `color: ${i}`,
    "color:black",
    ...o
  ) : console.log.bind(console) : () => {
  };
}
function h(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function P(...t) {
  throw new Error(t.join(""));
}
class l extends a.Component {
  constructor(e) {
    super(e);
    const n = this.constructor;
    this.debug = m(e, n), this.state = x(
      n.initialState,
      n.initialProps,
      e
    ), this.actions = C(this, n.actions);
  }
  getContext() {
    return {
      ...this.props,
      // properties passed to the context
      ...this.state,
      // internal state
      ...this.actions
      // callable action functions mapped to methods
    };
  }
  getRenderProps() {
    return this.getContext();
  }
  render() {
    return this.props.render(
      this.getRenderProps()
    );
  }
}
c(l, "initialState", {}), c(l, "initialProps", {}), c(l, "actions", []);
export {
  l as Context,
  $ as Generator
};
